export default function ContactModal({ t, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} id="contact-modal-close">×</button>
        <div className="modal-header-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </div>
        <h3 className="modal-title">{t.modalTitle}</h3>
        
        <form onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.target);
          const name = formData.get('name')?.trim();
          const email = formData.get('email')?.trim();
          const message = formData.get('message')?.trim();

          if (!name || !email || !message) {
            alert("Lütfen tüm alanları doldurun."); return;
          }
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(email)) {
            alert("Lütfen geçerli bir e-posta adresi girin."); return;
          }
          window.location.href = `mailto:ahmedoyan101@gmail.com?subject=İletişim Formu: ${name}&body=Gönderen: ${name} (${email})%0D%0A%0D%0A${message}`;
          onClose();
        }}>
          <div className="form-floating">
            <input type="text" name="name" required className="form-input" placeholder={t.phName} id="contact-name-input" />
          </div>
          <div className="form-floating">
            <input type="email" name="email" required className="form-input" placeholder={t.phEmail} id="contact-email-input" />
          </div>
          <div className="form-floating">
            <textarea name="message" required className="form-textarea" rows="5" placeholder={t.phMsg} id="contact-message-input"></textarea>
          </div>
          <button type="submit" className="btn-primary" style={{width: '100%', justifyContent: 'center'}} id="contact-submit-btn">
            {t.formBtn}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
          </button>
        </form>
      </div>
    </div>
  );
}
